import useAppContext from 'flow/hooks/useAppContext';
import { ExtensionKey } from 'flow/types/EntityKeys';
import useExtensionDisplayName from 'flow/hooks/useExtensionDisplayName';

export type AssigneeKey = ExtensionKey | 'unassigned';

// Resolves the display label for an assignee slot: "Unassigned" when no one
// is assigned, otherwise the extension's display name ("You"/name/"Unknown").
const useAssigneeLabel = (assigneeKey: AssigneeKey) => {
    const { i18next } = useAppContext();

    const displayName = useExtensionDisplayName(
        assigneeKey === 'unassigned' ? undefined : assigneeKey,
    );

    return assigneeKey === 'unassigned'
        ? i18next.t('tickets.unassigned.singular')
        : displayName;
};

export default useAssigneeLabel;
